import { Icon24SocialSignal } from '@care/react-embrace-icons';
import { type Theme, Typography } from '@mui/material';
import { Box, SxProps } from '@mui/system';

export interface HiredByProps {
  totalHires: number;
  sx?: SxProps<Theme>;
}

export const CaregiverHireCount = ({ sx = [], totalHires }: HiredByProps) => {
  return (
    <Box sx={[...(Array.isArray(sx) ? sx : [sx])]} display="flex" alignItems="center" columnGap={1}>
      <Icon24SocialSignal color="icon.brand" />
      <Typography variant="body2" component="span">
        Hired by {totalHires} families in your area
      </Typography>
    </Box>
  );
};
